import { FormHelperText, Grid } from '@mui/material'
import { translate } from '../../../../i18n'
import { NumberBox } from '../inputs/numberBox'
import { Control, useFormState } from 'react-hook-form';

interface TimerequiredUnitProps {
  name: string
  hourMax?: number
  hourMin?: number
  minuteMax?: number
  minuteMin?: number
  control: Control<any, any>;
  required?: boolean
}

export const TimerequiredUnit = (prpops: TimerequiredUnitProps) => {
  const { name, control, hourMax, hourMin, minuteMax, minuteMin, required } = prpops
  const hour = name + 'Hour'
  const minute = name + 'Minute'

  const { errors } = useFormState({ control });
  const hourError = errors[hour] ? errors[hour].message : null;
  const minuteError = errors[minute] ? errors[minute].message : null;

  return (
    <Grid item xs={6}>
      <Grid container alignItems="center">
        <Grid item xs={3} sm={2} lg={1.5}>
          <NumberBox
            name={hour}
            label={translate('accountCreateForm.label.timeRequired')}
            max={hourMax ?? 23}
            min={hourMin ?? 0}
            maxLength={2}
            required={required ?? false}
            control={control}
          />
        </Grid>
        <Grid item xs={3} sm={1.5} lg={1.2}>{translate("account.label.time")}</Grid>
        <Grid item xs={3} sm={2} lg={1.5}>
          <NumberBox
            name={minute}
            label={translate('accountCreateForm.label.timeRequired')}
            max={minuteMax ?? 59}
            min={minuteMin ?? 0}
            maxLength={2}
            required={required ?? false}
            control={control}
          />
        </Grid>
        <Grid item xs={3} sm={1.5} lg={1.2}>{translate("account.label.minute")}</Grid>
      </Grid>
      {(hourError || minuteError) && <FormHelperText error>{hourError ? hourError : minuteError}</FormHelperText>}
    </Grid>
  )
}

